import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const InvoiceIndicatorSchema = z
    .object({
        amount: z.number(),
        invoicesAmount: z.number(),
    })
    .strict();

export class InvoiceIndicator extends FromSchema(InvoiceIndicatorSchema) {
    amount: number;
    invoicesAmount: number;
}

export enum InvoiceIndicatorVariantsEnum {
    notDue = 'notDue',
    overDue = 'overDue',
    inProgress = 'inProgress',
    paid = 'paid',
    unpaid = 'unpaid',
}

export const InvoiceIndicatorVariantsSchema = EnumSchema(InvoiceIndicatorVariantsEnum);
export type InvoiceIndicatorVariants = keyof typeof InvoiceIndicatorVariantsEnum;

export const InvoiceIndicatorsResultSchema = z
    .object({
        unpaid: InvoiceIndicatorSchema,
        notDue: InvoiceIndicatorSchema,
        overdue: InvoiceIndicatorSchema,
        inProgress: InvoiceIndicatorSchema,
        paid: InvoiceIndicatorSchema,
    })
    .strict();

export class InvoiceIndicatorsResult extends FromSchema(InvoiceIndicatorsResultSchema) {
    unpaid: InvoiceIndicator;
    notDue: InvoiceIndicator;
    overdue: InvoiceIndicator;
    inProgress: InvoiceIndicator;
    paid: InvoiceIndicator;
}
